import React from "react";
import moment from "moment";

export default function NotificationItemComponent({ item }) {
  const { is_read_by_candidate, message, created_at } = item;
  return (
    <div
      className="notification-item px-2"
      style={{ backgroundColor: is_read_by_candidate ? "none" : "#edf4f8" }}
    >
      <div className="">
        <p>{message}</p>
        <span className="time">
          <i className="fa fa-clock-o" /> {moment(created_at).fromNow()}
        </span>
      </div>
    </div>
  );
}
